/**
 * Возвращает true, если значение равно null или undefined
 */
function isNullable(value) {
    return !isNonNullable(value);
}
function isNonNullable(value) {
    return value != null;
}
/**
 * Выбор значения между min max границами
 */
function clamp(value, min, max) {
    var clampedValue = Math.min(Number(max), Math.max(Number(min), Number(value)));
    return (value instanceof Date ? new Date(clampedValue) : clampedValue);
}
function noop() { }
var fnUtils = {
    clamp: clamp,
    noop: noop,
    isNil: isNullable,
};

export { fnUtils, isNonNullable, isNullable, noop };
